/*
 * Models for the Topics Using Category Modal list.
 */

define([
  "backbone",
  "jquery",
  "messaging/messenger",
  "configuration/properties",
  "modules/shared/sortableList/sortableListModel",
], function (Backbone, $, Messenger, Properties, SortableListModel) {
  var TopicsUsingCategoryModel = {};

  TopicsUsingCategoryModel.topicUsingCategory = Backbone.Model.extend({
    idAttribute: "intentId",
  });

  TopicsUsingCategoryModel.topicsUsingCategory = Backbone.Collection.extend({
    model: TopicsUsingCategoryModel.topicUsingCategory,
    url: function () {
      // either categoryId or categoryValueId should be defined. Both cannot and should not be defined. This is
      // because fetching of topics using category code should be triggered either when deleting an entire category
      // or when deleting a single category value
      if (this.categoryId) {
        return Properties.rootURL + "/" + this.kbId + "/intentsUsingCategory/" + this.categoryId;
      } else if (this.categoryValueId) {
        return (
          Properties.rootURL +
          "/" +
          this.kbId +
          "/intentsUsingCategoryValue/" +
          this.categoryValueId
        );
      }
    },
  });

  Messenger.reqres.setHandler("topics:using:category:headers", function () {
    var Header = SortableListModel.headerModel;
    return new Backbone.Collection([
      new Header({
        headerName: $.t("admin.categories.category.topicsUsingCategoryList.topicName"),
        modelAttribute: "intentName",
      }),
      new Header({
        headerName: $.t("admin.categories.category.topicsUsingCategoryList.topicId"),
        modelAttribute: "intentId",
      }),
    ]);
  });

  Messenger.reqres.setHandler(
    "fetch:topics:using:category",
    function (kbId, categoryId, categoryValueId) {
      var topicsUsingCategory = new TopicsUsingCategoryModel.topicsUsingCategory();
      topicsUsingCategory.kbId = kbId;
      topicsUsingCategory.categoryId = categoryId;
      topicsUsingCategory.categoryValueId = categoryValueId;
      topicsUsingCategory.fetch();
      return topicsUsingCategory;
    },
  );
});
